import { useEpiEditButtonRepositioning } from './EpiQuickNavigatorButton.hooks';

const EpiQuickNavigatorButton = () => {
    const ref = useEpiEditButtonRepositioning();

    return <div ref={ref} style={{ position: 'absolute', bottom: 0, right: 0 }} />;
};

export default EpiQuickNavigatorButton;
